import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone } from "lucide-react";

const HIDE_ON_PATHS = ["/login", "/register", "/verify-phone", "/admin", "/dashboard", "/consultation", "/accept-invite"];

export default function StickyConsultCta() {
    const [show, setShow] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 600);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const hide = HIDE_ON_PATHS.some((p) => location.pathname === p || location.pathname.startsWith(p + "/"));
    if (hide || !show) return null;

    return (
        <Link
            to="/consultation"
            data-testid="sticky-consult-cta"
            className="fixed bottom-6 right-6 z-40 group flex items-center gap-2 bg-coral text-white pl-4 pr-5 py-3 rounded-full shadow-2xl hover:scale-105 transition-transform font-app font-semibold text-sm"
            aria-label="Talk to the Bula team"
        >
            <span className="relative flex h-2.5 w-2.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" />
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-white" />
            </span>
            <Phone className="h-4 w-4" />
            Talk to us
        </Link>
    );
}
